// extracted by mini-css-extract-plugin
module.exports = {"displayVillageImage":"MasterplanImage_displayVillageImage__2jfzY"};